import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, RcmsCotacao } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class RcmsCotacaoService extends BaseResourceService<RcmsCotacao> {

  constructor(
    protected injector: Injector
  ) {
    super(`rcms-cotacoes`, injector);
  }

}
